export enum AffairesSearchFiltre {
	Toutes = 'toutes',
	Courantes = 'courantes',
	Soldees = 'soldees',
	WithCheques = 'withCheques',
	Aarchiver = 'aarchiver',
	Archivees = 'archivees',
	Cloturees = 'cloturees'
}

export enum CommonEtat {
	None = 'none',
	Accepte = 'accepte',
	AccepteNiveau3 = 'accepteNiveau3',
	Refuse = 'refuse',
	RefuseNiveau3 = 'refuseNiveau3',
	Enregistre = 'enregistre',
	Valide = 'valide',
	ValideNiveau3 = 'valideNiveau3',
	ValideFacteurRisque = 'valideFacteurRisque',
	EnregistreFacteurRisque = 'enregistreFacteurRisque',
	Soumis = 'soumis',
	Modifie = 'modifie',
	Archive = 'archive',
	Transfere = 'transfere',
	Renvoye = 'renvoye',
	RenvoyePourInfoAuFO = 'renvoyePourInfoAuFO',
	RenvoyePourModifAuFO = 'renvoyePourModifAuFO',
	RenvoyePourInfoAuBO = 'renvoyePourInfoAuBO',
	RenvoyePourModifAuBO = 'renvoyePourModifAuBO'
}

export enum CommonAffaireEtat {
	None = 'none',
	EnCoursDeTraitement = 'enCoursDeTraitement'
}

export enum CommonComportement {
	Informatif = 'informatif',
	BloquantEnSaisie = 'bloquantEnSaisie',
	BloqueEnValidation = 'bloqueEnValidation',
	BloqueEnGeneration = 'bloqueEnGeneration',
	AlerteEnSaisie = 'alerteEnSaisie',
	BloqueAuto = 'bloqueAuto'
}

export enum DefaultNature {
	NatureOperationDebitId = 'NatureOperationDebitId',
	NatureOperationCreditId = 'NatureOperationCreditId'
}

export enum UnarchiveFilter {
	Non = 'non, merci',
	OuiPdf = 'oui, imprimer au format pdf',
	OuiCsv = 'oui, exporter au format csv'
}

export enum AffaireCompteFiltres {
	Toutes = 'Toutes',
	Courantes = 'Courantes',
	Soldees = 'Soldees',
	Stagnantes = 'Stagnantes',
	WithCheques = 'WithCheques',
	Actives = 'Actives',
	Archivees = 'Archivees'
}